module.exports = __webpack_public_path__ + "media/images/msk-7a0f042d7b110280e2ecb60c31696416.png";